import React, { forwardRef } from 'react';
import styles from './Input.module.css';

const Input = forwardRef(function Input(
  { hasError, className = '', ...props },
  ref
) {
  return (
    <input
      ref={ref}
      className={[styles.input, hasError ? styles.err : '', className].join(' ')}
      {...props}
    />
  );
});

export default Input;
